/**
 * @generated SignedSource<<18f00fc150134d3e28db22d9ad263e89>>
 * @relayHash ccd2cd57b96d01e796a5305915df0306
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e7bcbd9ccb0157071106ad1f289719ca9ee0c599161c648ce22c5d3f7ff53c17

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpObjectStoreArticleContentType = "FOLDER" | "PAGE" | "%future added value";
export type HelpObjectStoreArticleSearchExpandType = "ANCESTORS" | "VIEW_COUNT" | "%future added value";
export type HelpObjectStoreSupportSiteArticleSearchInput = {
  articleIds?: ReadonlyArray<string> | null | undefined;
  contentTypes?: ReadonlyArray<HelpObjectStoreArticleContentType> | null | undefined;
  expand?: ReadonlyArray<HelpObjectStoreArticleSearchExpandType> | null | undefined;
  orderBy?: string | null | undefined;
  parentId?: AGG$Long | null | undefined;
  query?: string | null | undefined;
  topLevelArticlesOnly?: boolean | null | undefined;
};
export type csmFolderSearchArticlesForSupportSiteQuery$variables = {
  cloudId: string;
  first?: number | null | undefined;
  helpCenterAri: string;
  input?: HelpObjectStoreSupportSiteArticleSearchInput | null | undefined;
};
export type csmFolderSearchArticlesForSupportSiteQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"mainCsmFolderItemsRenderer_data">;
};
export type csmFolderSearchArticlesForSupportSiteQuery = {
  response: csmFolderSearchArticlesForSupportSiteQuery$data;
  variables: csmFolderSearchArticlesForSupportSiteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "title"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "csmFolderSearchArticlesForSupportSiteQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "mainCsmFolderItemsRenderer_data"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "csmFolderSearchArticlesForSupportSiteQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticlesForSupportSite",
        "plural": false,
        "selections": [
          {
            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "contentType"
                      },
                      {
                        "concreteType": "HelpObjectStoreArticleRelative",
                        "kind": "LinkedField",
                        "name": "ancestors",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "HelpObjectStoreArticleURLInfo",
                        "kind": "LinkedField",
                        "name": "urlInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "shareUrl"
                          }
                        ]
                      }
                    ],
                    "type": "HelpObjectStoreSupportSiteArticleSearchResult"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "message"
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "filters": [
          "helpCenterAri",
          "cloudId",
          "input"
        ],
        "handle": "connection",
        "key": "CsmFolderItemsRenderer__helpObjectStore_searchArticlesForSupportSite",
        "kind": "LinkedHandle",
        "name": "helpObjectStore_searchArticlesForSupportSite"
      }
    ]
  },
  "params": {
    "id": "e7bcbd9ccb0157071106ad1f289719ca9ee0c599161c648ce22c5d3f7ff53c17",
    "metadata": {},
    "name": "csmFolderSearchArticlesForSupportSiteQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4e2df91a41eb5d8ce8ae2f48a0e1068e";

export default node;
